@if (mediaForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="mediaForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Media Direction </label>
            </div>
            <mat-button-toggle-group #directionGroup="matButtonToggleGroup"
              [value]="mediaForm?.controls['mediaDirection']?.value" [multiple]="false"
              [formControlName]="'mediaDirection'"
              (change)="directionChanged(directionGroup)"
              class="control-input control-toggle-group"
              hideSingleSelectionIndicator>
              <mat-button-toggle class="selector-button" [value]="'inbound'">Inbound</mat-button-toggle>
              <mat-button-toggle class="selector-button" [value]="'outbound'">Outbound</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          @switch (directionGroup.value) {
            @case ('inbound') {
              <ng-container [ngTemplateOutlet]="inboundForm"></ng-container>
            }
            @case ('outbound') {
              <ng-container [ngTemplateOutlet]="outboundForm"></ng-container>
            }
          }
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
    @if (directionGroup.value === 'inbound' || mediaForm.controls.endSession.value === false) {
      <clickatell-expansion-panel
        >
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <div class="control-div">
            <label class="control-label">
              <span class="pont-to">Point To</span>
            </label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
            @if (nodeFlowDetails) {
              <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                [stepId]="nodeFlowDetails.stepId"
                [name]="'next'"
                [form]="mediaForm">
                >
              </next-selector>
            }
          </div>
        </ng-container>
      </clickatell-expansion-panel>
    }
  </div>
}

<ng-template #inboundForm>
  <ng-container [formGroup]="mediaForm">

    <div class="control-div">
      <div class="control-label-container">
        <label class="control-label"> Variable </label>
      </div>
      <clickatell-form-validation [controlName]="'varName'"
      [form]="mediaForm"></clickatell-form-validation>
      <input class="control-input" activeForm [activeForm]="mediaForm" id="varName"
        [formControlName]="'varName'" placeholder="Enter a variable"/>
      </div>

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label"> Text </label>
        </div>
        <clickatell-form-validation [controlName]="'text'"
        [form]="mediaForm"></clickatell-form-validation>
        <textarea class="control-textArea" activeForm [activeForm]="mediaForm" id="text" [formControlName]="'text'"
        style="resize: none"></textarea>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #outboundForm>
    <ng-container [formGroup]="mediaForm">

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label"> Source </label>
        </div>
        <mat-button-toggle-group #varType="matButtonToggleGroup" [value]="mediaForm?.controls['varType']?.value"
          [multiple]="false"
          [formControlName]="'varType'"
          (change)="sourceChanged(varType)" class="control-input control-toggle-group"
          hideSingleSelectionIndicator>
          <mat-button-toggle class="selector-button" [value]="'API'">API</mat-button-toggle>
          <mat-button-toggle class="selector-button" [value]="'Assets'">Assets</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      @switch (varType.value) {
        @case ('API') {
          <ng-container [ngTemplateOutlet]="api"></ng-container>
        }
        @case ('Assets') {
          <ng-container [ngTemplateOutlet]="assets"></ng-container>
        }
      }

      <div class="control-div toggle-field">
        <div class="label-left-block">
          <label class="control-label"> End Session </label>
        </div>
        <div class="toggle-btn">
          <mat-slide-toggle #next="matSlideToggle" [color]="'primary'" class="end-session"
            [formControlName]="'endSession'" (change)="sessionEndToggle(next.checked)">
          </mat-slide-toggle>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #api>
    <ng-container [formGroup]="mediaForm">
      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label"> Variable </label>
        </div>
        <clickatell-form-validation [controlName]="'varName'"
        [form]="mediaForm"></clickatell-form-validation>
        <input class="control-input" activeForm [activeForm]="mediaForm" id="varName"
          [formControlName]="'varName'" placeholder="Enter a variable"/>
        </div>

        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Caption (Optional) </label>
          </div>
          <clickatell-form-validation [controlName]="'text'"
          [form]="mediaForm"></clickatell-form-validation>

          <textarea class="control-textArea" activeForm [activeForm]="mediaForm" id="text"
          [formControlName]="'text'" placeholder="Enter a caption" [attr.name]="'text'"></textarea>
        </div>

        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> File Name Override (Optional) </label>
          </div>
          <clickatell-form-validation [controlName]="'filename'"
          [form]="mediaForm"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="mediaForm" id="filename"
            [formControlName]="'filename'" placeholder="Enter a file name"/>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #assets>
        <ng-container [formGroup]="mediaForm">
          <div class="control-div">
            <input #imageRef [formControlName]="'varName'" hidden>
            <select-media [image]="imageRef.value" [imageOnly]="false" (setImageRef)="setImage($event, mediaForm)">
            </select-media>
          </div>

          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Caption (Optional) </label>
            </div>
            <clickatell-form-validation [controlName]="'text'"
            [form]="mediaForm"></clickatell-form-validation>

            <textarea class="control-textArea" activeForm [activeForm]="mediaForm" id="text"
            [formControlName]="'text'" placeholder="Enter a caption" [attr.name]="'text'"></textarea>
          </div>

          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> File Name Override (Optional) </label>
            </div>
            <clickatell-form-validation [controlName]="'filename'"
            [form]="mediaForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="mediaForm" id="filename"
              [formControlName]="'filename'" placeholder="Enter a file name"/>
            </div>
          </ng-container>
        </ng-template>